import Icon from '@cobliteam/colib-ui/Icon';
import { useTranslation } from '@cobliteam/i18n';

const AlertIcon = ({ className, size = 'sm' }: { className?: string; size?: 'xs' | 'sm' | 'md' | 'lg' }) => {
  const { t } = useTranslation('common');
  const sizeClass = {
    xs: 'size-4',
    sm: 'size-5',
    md: 'size-6',
    lg: 'size-7',
  };
  return (
    <div className={className}>
      <span className={`relative flex ${sizeClass[size]}`}>
        <span className='absolute inline-flex h-full w-full animate-ping rounded-full bg-destructive/15 opacity-75' />
        <span className={`relative inline-flex ${sizeClass[size]} items-center justify-center rounded-full bg-destructive/15`}>
          <Icon name='circle-alert' aria-label={t('messages.warning')} size='sm' className='text-destructive' />
        </span>
      </span>
    </div>
  );
};
export default AlertIcon;
